import { h } from "preact";
import { useEffect, useMemo, useRef, useState } from "preact/hooks";

const nativeImport = new Function("url", "return import(url)") as <T>(url: string) => Promise<T>;

type PreactModule = {
    InfiniteCanvas: (props: {children?: any}) => h.JSX.Element
};

let ImportedComponent: ((props: {children?: any}) => h.JSX.Element)|null = null;

export function InfiniteCanvas() {
    const [state, setState] = useState(0);

    useEffect(() => {
        if(ImportedComponent) return;
        nativeImport<PreactModule>("/modules/infinitecanvas.esm.js")
            .then(code => {
                ImportedComponent = code.InfiniteCanvas;// () => <h1>Foo</h1>
                setState(1);
            });
    }, []);

    if(!ImportedComponent) return null;
console.log("---rendering")
    return (
        <ImportedComponent>
            Hello I'm the infinite canvas
        </ImportedComponent>
    )
}